import { gql } from 'graphql-request'

export const UPDATE_WRITER_CONSENT = gql`
  mutation UpdateWriterConsent($consentId: Int!) {
    updateWriterConsent(consentId: $consentId)
  }
`
